import { SearchWithFacetsBodyParser } from './models';

const searchWithFacetsBodyParser = ({
  searchQuery,
  pageId,
  facets,
  from,
  hitsPerPage,
  sortOrder,
  indexName,
  resultsSubTags,
}: SearchWithFacetsBodyParser) => {
  const mustQueries: any = [];
  const searchableAttributes =
    indexName === `${process.env.GATSBY_ELASTIC_INDEX}-articles`
      ? ['title', 'previewText', 'url']
      : ['title', 'url', 'summaryText'];

  if (facets) {
    Object.keys(facets).forEach((facetKey) => {
      const activeFacetValues = facets[facetKey]
        .filter((item) => item.isRefined)
        .map((item) => item.label);

      if (activeFacetValues.length > 0) {
        mustQueries.push({
          terms: {
            [`${facetKey}.keyword`]: activeFacetValues,
          },
        });
      }
    });
  }

  if (searchQuery?.trim()) {
    mustQueries.push({
      bool: {
        should: [
          ...searchableAttributes.map((field) => ({
            match: {
              [field]: {
                query: searchQuery,
                fuzziness: 'AUTO',
                operator: 'and',
              },
            },
          })),
          ...searchableAttributes.map((field) => ({
            match_phrase_prefix: { [field]: searchQuery },
          })),
        ],
        minimum_should_match: 0,
      },
    });
  }

  if (pageId) {
    mustQueries.push({
      term: {
        landingPageId: pageId,
      },
    });
  }

  if (resultsSubTags && resultsSubTags.length > 0) {
    mustQueries.push({
      terms: {
        'articleSubTags.name.keyword': resultsSubTags,
      },
    });
  }

  return {
    query: mustQueries.length > 0 ? { bool: { must: mustQueries } } : { match_all: {} },
    size: hitsPerPage,
    from: from || 0,
    ...(sortOrder &&
      indexName &&
      indexName === `${process.env.GATSBY_ELASTIC_INDEX}-articles` && {
        sort: [{ creationDate: { order: sortOrder } }],
      }),
  };
};

export default searchWithFacetsBodyParser;
